<template>
	<div v-if="companies.length > 0">
		<div class="black-text font-weight-black mt-1">Work Experience</div>

		<div v-for="company in companies" :key="company" class="pr-1">
			<v-icon left color="primary" :size="18">{{ workExperienceIcon }}</v-icon>
			<small>{{ companyLabel(company) }}</small>
		</div>
	</div>
</template>

<script>
import store from '@/store';
import { resolveEstablishmentTypeLabel } from '@utils';

export default {
	name: 'LocumWorkExperience',
	props: {
		companies: Array,
	},
	computed: {
		workExperienceIcon() {
			return this.tenant?.settings?.workflow?.professionalProfile?.workExperienceIcon || 'mdi-medical-bag';
		},
	},
	methods: {
		companyLabel(codeOrName) {
			const fromKeys = store.getters.configs?.industryKeys?.[codeOrName];
			if (fromKeys) return fromKeys;
			return resolveEstablishmentTypeLabel(codeOrName, store.getters.configs?.industriesV2);
		},
	},
};
</script>
